import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/storeBundles';

export const STORE_BUNDLE_MERCHANTS_GET_SUCCESS = `${rootActionPath}Merchants/GET_${SUCCESS_SUFFIX}`;
export const STORE_BUNDLE_MERCHANTS_GET_FAILURE = `${rootActionPath}Merchants/GET_${FAILURE_SUFFIX}`;

export const STORE_BUNDLE_ASSETS_GET_SUCCESS = `${rootActionPath}Assets/GET_${SUCCESS_SUFFIX}`;
export const STORE_BUNDLE_ASSETS_GET_FAILURE = `${rootActionPath}Assets/GET_${FAILURE_SUFFIX}`;
